import { render, staticRenderFns } from "./purchaseReturns.vue?vue&type=template&id=05918cd4&"
import script from "./purchaseReturns.vue?vue&type=script&lang=js&"
export * from "./purchaseReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports